var SvgPanZoom = require("./svg-pan-zoom.js");

module.exports = SvgPanZoom;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-pan-zoom/src/browserify.js
// module id = bNUd
// module chunks = 115 116